import { type FC, useState } from "react";
import { ActionButton, HStack, Icons, ItemTile, VStack } from "widgets";

import { useError } from "@/app-utils/graphql/useError.ts";
import type { User } from "@/graphql.ts";
import { getUserDisplayName } from "@/modules/users/utils/user.ts";
import { SelectWorkflowControlledDialog } from "@/modules/workflow/components/ControlledDialogSelectWorkflow.tsx";
import { WorkflowEditorStoreProvider } from "@/modules/workflow/components/WorkflowEditorStoreProvider.tsx";
import { useLoadWorkflowPreviewDetailsQuery } from "@/modules/workflow/graphql/workflow.gql.ts";
import { SELECTABLE_WORKFLOW_TYPE } from "@/modules/workflow/utils/types.ts";

interface IWorkflowSelectProps {
  defaultSelectedWorkflowId: number;
  handleChange: (workflowId: number) => void;
}

const WorkflowSelect: FC<IWorkflowSelectProps> = (props) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const { data, loading, error } = useLoadWorkflowPreviewDetailsQuery({
    variables: { workflowId: props.defaultSelectedWorkflowId },
    skip: !props.defaultSelectedWorkflowId,
  });
  void useError(error);
  const onWorkflowSelect = (workflowId: number | null | undefined) => {
    if (workflowId) {
      props.handleChange(workflowId);
    }
    setOpen(false);
  };
  const workflow = data?.workflow?.findWorkflowById;

  return (
    <VStack>
      <WorkflowEditorStoreProvider>
        <SelectWorkflowControlledDialog
          isOpen={isOpen}
          onSelect={onWorkflowSelect}
          onClose={() => setOpen(false)}
          defaultSelectedWorkflowId={props.defaultSelectedWorkflowId}
          restrictSelectableType={SELECTABLE_WORKFLOW_TYPE.PUBLISHED}
        />
      </WorkflowEditorStoreProvider>
      <HStack>
        {!loading && workflow ? (
          <ItemTile
            icon={<img src={Icons.Tiles.Workflow} width={24} height={30} alt="" aria-hidden />}
            name={workflow.name}
            id={workflow.id}
            userInfoTag={getUserDisplayName(workflow.creator as User)}
            dateInfoTag={workflow.modified ?? workflow.created}
            style={{ width: "100%", cursor: "default" }}
          />
        ) : null}
        <ActionButton label={"Select Workflow"} onPress={() => setOpen(true)} />
      </HStack>
    </VStack>
  );
};

export { type IWorkflowSelectProps, WorkflowSelect };
